import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { useCallback, useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { dmsState } from '@/app/store'
import { PageWrapper } from '@/shared'

import style from './Dms.module.scss'
import { ModeFilter } from './ModeFilter/ModeFilter'

export const Dms = observer(() => {
    const onGetInitialData = useCallback(() => {
        if (dmsState.guideMarkers.length < 1) {
            dmsState.onGetGuideMarkers()
        }
        if (!dmsState.insuredsList) {
            dmsState.onGetInsuredsList()
        }
        if (!dmsState.companiesList) {
            dmsState.onGetCompaniesList()
        }
        if (!dmsState.importHistory) {
            dmsState.onGetImportHistory()
        }
        return () => dmsState.onZeroDmsData()
    }, [])

    useEffect(onGetInitialData, [onGetInitialData])

    return (
        <div className={classNames(style.container, dmsState.isFetching && style.containerFetching)}>
            <PageWrapper>
                <ModeFilter />
                <Outlet />
            </PageWrapper>
        </div>
    )
})
